import { ApplicationInsights, IEventTelemetry } from '@microsoft/applicationinsights-web'
import { Settings } from './Settings'
import { version } from './Version'

let insights: ApplicationInsights
// https://github.com/microsoft/ApplicationInsights-JS

export function ConfigureTelemetry() {
	insights = new ApplicationInsights({
		config: {
			disableAjaxTracking: true,
			disableExceptionTracking: true,
			disableFetchTracking: true,
			connectionString: import.meta.env.PROD ? Settings.telemetryConnectionString : Settings.testTelemetryConnectionString,
			disableCookiesUsage: true,
			disablePageUnloadEvents: ['beforeunload', 'unload'],
			enableDebug: true
		},
		sv: version
	})
	insights.loadAppInsights()
	insights.context.application.ver = version
	insights.context.application.build = import.meta.env.VITE_BUILDID

	const userData = JSON.parse(localStorage.getItem('ngx-webstorage|userdata'))
	if (userData?.Alias) insights.setAuthenticatedUserContext(userData.Alias.toUpperCase(), userData.CustomerNo.toUpperCase(), false)
}

export function TrackEvent(pageView: IEventTelemetry) {
	if (insights) insights.trackEvent(pageView)
}

export function TrackException(exception: Error, data: Object = null) {
	if (insights) insights.trackException({ exception: exception }, data)
}
